import React, { useEffect, useContext } from 'react'
import { useAppState } from '../../hooks'
import api from '../../api-client'
import { toast } from 'react-toastify'
import { BannedInstaller } from '@oneethos/shared'
import { AppContext } from '../../appContext'
import actions from '../../actions'

const BannedInstallers = () => {
  const { tenant: { config: tenant } } = useAppState()
  const { dispatch } = useContext(AppContext)
  const bannedInstallers = tenant?.bannedInstallers

  const handleUnbannedInstaller = (installer : BannedInstaller) => {
    if (window.confirm(`Are you sure you want to unban ${installer.email}? They will be able to log in again.`)) {
      api.post(`/installers/${installer._id}/unban`)
        .then((res) => {
          toast.success(res.message)
          dispatch(actions.setTenant(res.tenant))
        })
        .catch(ex => {
          toast.error(ex.error || ex.message)
        })
    }
  }

  return (
    <>
     {bannedInstallers && bannedInstallers.length === 0 ? 
      <div className='alert alert-light' role='alert'>No installers are currently banned.</div> : 
      <div className="table-list-wrap">
      <table className="table">
        <tbody>
            <tr className='text-center'>
            <th className='text-start'>Name</th>
            <th className='text-start'>Installer ID</th>
            <th>Access</th>
            <th>Email</th>
            <th>Phone</th>
            <th></th>
          </tr>
          {bannedInstallers.map(installer => 
            <tr key={installer.email} className='text-center align-middle'>
              <td className='text-start'>{installer.name}</td>
              <td className='my-3 text-capitalize text-start'>{installer.installerID}</td>
              <td>{installer.access}</td>
              <td>{installer.email}</td>
              <td>{installer.phone}</td>
              <td>
                <button 
                  type="button" 
                  className="btn btn-outline-secondary btn-sm"
                  onClick={ () => handleUnbannedInstaller(installer)}
                >
                  Unban User
                </button>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>}
    </>
  )
}

export default BannedInstallers